export default __webpack_public_path__ + "static/media/producto-11.4d81a67f.jpg";